import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const Collective = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.collective.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.collective.paragraph" />
          </Subtitle>
        </Contentwrapper>
        <ImageWrapper>
          <StyledImage
            src={messages['home.collective.image.src']}
            alt={messages['home.collective.image.alt']}
          />
        </ImageWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Collective;
